export const REDUCER_KEY_AI_SEARCH_SUMMARY = 'aiSearchSummary';

// Transient-attempt status (SD-1). Completed summaries have no status; "nothing requested yet"
// is represented by an empty `summaries` array and a null `attempt`.
export const SUMMARY_STATUS = {
  LOADING: 'LOADING',
  ERROR: 'ERROR',
};

export const SUMMARY_SCOPE = {
  TOP: 'TOP',
  SELECTED: 'SELECTED',
};

export const MIN_SELECTED_RESULTS = 1;
export const MAX_SELECTED_RESULTS = 20;
export const SUMMARY_SELECTION_ERROR = 'Select up to 20 results to generate a summary';

export const isSummarySelectionValid = (selectedItems = []) =>
  selectedItems.length >= MIN_SELECTED_RESULTS && selectedItems.length <= MAX_SELECTED_RESULTS;

export const SUMMARY_POLLING_INTERVAL = 2000;
// Per AR-1.5: cap total polling duration and attempt count, and stop polling while the tab is hidden.
export const SUMMARY_POLLING_MAX_ATTEMPTS = 150; // ~5 minutes at 2s intervals
export const SUMMARY_POLLING_MAX_DURATION = 5 * 60 * 1000;

export const SUMMARY_POLLING_STATUS = {
  PENDING: 'PENDING',
  COMPLETED: 'COMPLETED',
  ERROR: 'ERROR',
};

// BE error codes (SD-4 item 6 / RX-24693 Data Requirements).
export const SUMMARY_ERROR_CODE = {
  INVALID_CONTEXT: 'INVALID_CONTEXT',
  MISSING_REQUIRED_FIELD: 'MISSING_REQUIRED_FIELD',
  EMPTY_SELECTION: 'EMPTY_SELECTION',
  SELECTION_LIMIT_EXCEEDED: 'SELECTION_LIMIT_EXCEEDED',
  INVALID_RESULT_ID: 'INVALID_RESULT_ID',
  RESULT_SET_NOT_FOUND: 'RESULT_SET_NOT_FOUND',
  SUMMARY_NOT_FOUND: 'SUMMARY_NOT_FOUND',
  SUMMARIZATION_DISABLED: 'SUMMARIZATION_DISABLED',
  SUMMARIZATION_FORBIDDEN: 'SUMMARIZATION_FORBIDDEN',
  DOWNSTREAM_SUMMARIZATION_FAILED: 'DOWNSTREAM_SUMMARIZATION_FAILED',
};

// SD-1 retention bounds. The transient generation attempt is stored separately and does not
// count against the completed-summary cache.
export const MAX_SUMMARIES_PER_CHAIN = 10;
export const MAX_CHAINS = 5;

export const SUMMARY_ENTRY_START = 'SUMMARY_ENTRY_START';
export const SUMMARY_ENTRY_ACCEPTED = 'SUMMARY_ENTRY_ACCEPTED';
export const SUMMARY_ENTRY_SUCCESS = 'SUMMARY_ENTRY_SUCCESS';
export const SUMMARY_ENTRY_ERROR = 'SUMMARY_ENTRY_ERROR';
export const SUMMARY_ENTRY_CANCELLED = 'SUMMARY_ENTRY_CANCELLED';
export const SUMMARY_ENTRY_FEEDBACK = 'SUMMARY_ENTRY_FEEDBACK';
export const SUMMARY_ENTRY_ADD_VALID_RESULT_NAME = 'SUMMARY_ENTRY_ADD_VALID_RESULT_NAME';
export const RESET_SUMMARY_STATE = 'RESET_SUMMARY_STATE';

// AR-1.4: composite chain key — stable across filters within a chain, unlike the active resultName.
export const buildChainKey = ({ databaseId, context, rootResultName }) => `${databaseId}:${context}:${rootResultName}`;
